import { LinkButton } from '@euler/app/components/LinkButton';
import { Typography } from '@euler/app/components/typography';
import { useOrderFlowContext } from '@euler/app/flows/order/OrderFlowContext';
import { Img } from '@euler/components/image/AdvancedImage';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { safeMarkDevFlag } from '@euler/utils';
import { useBehaviorSubject, usePersistFn } from '@euler/utils/hooks';
import { memo } from 'react';
import { View } from 'react-native';
import { OrderPreviewSection as Section } from './Section';

const kSimulateUnsigned = safeMarkDevFlag(false);

export const CustomerSignSection = memo(
  ({ signImageUrl }: { signImageUrl?: string }) => {
    const { rpx } = useResponsiveContext();
    const {
      showDigitalSignModal$,
      isSignUnavailable$,
      showTermsOfServiceModal$,
      storeConfiguration,
    } = useOrderFlowContext();

    const [isSignUnavailable] = useBehaviorSubject(isSignUnavailable$);

    const canReSign = Boolean(signImageUrl && !kSimulateUnsigned);

    const onSignPress = usePersistFn(() => {
      if (canReSign || storeConfiguration.app?.orderFlow?.skipSign) {
        showDigitalSignModal$.next(true);
      } else {
        showTermsOfServiceModal$.next(true);
      }
    });

    return (
      <Section
        title="客户签字"
        headerRight={
          <LinkButton
            text={canReSign ? '重签' : '签名'}
            onPress={onSignPress}
          />
        }
      >
        {canReSign ? (
          <View
            css={`
              padding: ${rpx(15)}px;
            `}
          >
            <Img
              uri={signImageUrl}
              resizeMode="contain"
              css={`
                aspect-ratio: ${5 / 3};
              `}
            />
          </View>
        ) : (
          <View
            css={`
              padding: ${rpx(15)}px;
            `}
          >
            <Typography.Label color="#777">
              {isSignUnavailable ? '客户未在厂' : '尚未签名'}
            </Typography.Label>
          </View>
        )}
      </Section>
    );
  },
);
